<template>
	<div>
		<t-config-provider>
			<t-layout>
				<Header />
				<t-content class="content-container">
					<section class="content-main">
						<router-view />
					</section>
				</t-content>
			</t-layout>
		</t-config-provider>
	</div>
</template>

<script setup lang="ts">
import Header from './Header/index.vue'
import store from '@/store'
import { onMounted } from 'vue'

const { platform } = store()

onMounted(() => {
	window.addEventListener('resize', () => {
		platform.setIsMobile(window.innerWidth < 768)
	})
})
</script>

<style scoped lang="scss">
.content-container {
	padding: var(--td-size-6);
	overflow-y: auto;
	background-color: #eee;
	margin: 0 auto;
	max-width: 1440px;
	width: 100%;
	box-sizing: border-box;

	.content-main {
		background-color: #fff;
		padding: var(--td-size-6);
		border-radius: var(--td-size-4);
		min-height: calc(100vh - 56px - 32px);
		width: 100%;
		box-sizing: border-box;
	}
}

// 响应式适配
@media (max-width: 1472px) {
	.content-container {
		margin: 0 var(--td-size-6);
		max-width: calc(100% - 32px);
	}
}

@media (max-width: 768px) {
	.content-container {
		padding: var(--td-size-4);
		margin: 0 var(--td-size-4);
		max-width: calc(100% - 16px);

		.content-main {
			padding: 12px;
		}
	}
}

@media (max-width: 480px) {
	.content-container {
		padding: 4px;
		margin: 0 4px;
		max-width: calc(100% - 8px);

		.content-main {
			padding: 8px;
		}
	}
}
</style>
